module.exports = new __parcel__URL__("bulls-blue.70a6ca39.svg").toString();